import shop from '~/lib/api/shop';
import { ShopTypes } from '~/lib/data-contract';
import { getUrl } from '~/services/shop/utils';
import { minutes } from '~/shared/utils/helpers';

type Args = {
    signal: AbortSignal | undefined;
    customerId: string | null;
    token: string | null;
};

export default function getAccountInfo({ signal, customerId, token }: Args) {
    return shop
        .get(getUrl(`/customers/${customerId}/debtor`), {
            signal,
            headers: {
                Authorization: `Bearer ${token}`,
            },
            timeout: minutes(1),
        })
        .json<ShopTypes.CustomerInfoHeader[]>();
}
